import 'jquery';
import 'jquery-ui-dist/jquery-ui';
import 'bootstrap/dist/js/bootstrap';
import 'src/vendor/summernote/summernote';
import angular from 'angular';
import 'datatables';
import 'handsontable/dist/handsontable.full';
import 'src/vendor/angular-datatables/angular-datatables';
import 'ng-handsontable/dist/ngHandsontable';
import 'angular-ui-router';
import 'angular-resource';
import 'angular-cookies';
import 'angular-permission';
import 'angular-segment-analytics';
import 'angular-ui-bootstrap';
import 'ng-currency/dist/ng-currency';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module';
import 'ng-onload/release/ng-onload';
import 'ngdraggable';
import 'ngclipboard';
import 'angularjs-autogrow';
import 'angular-summernote/dist/angular-summernote';
import 'src/vendor/angular-slideout-panel/angular-slideout-panel.min';
import 'js-sdk';
import 'messenger/build/js/messenger';
import 'clndr';
import 'bootstrap-daterangepicker/daterangepicker';
import 'src/vendor/angular-daterangepicker/angular-daterangepicker';
import 'src/vendor/bootstrap-timepicker/bootstrap-timepicker';
import 'src/vendor/angular-labelauty/app';
import 'ui-select/dist/select';
import 'src/vendor/offline-js/offline';
import 'src/vendor/angular-hljs/angular-hljs';
import 'angular-nvd3';
import smoothScrollPolyfill from 'smoothscroll-polyfill';

import npHttpInterceptor from 'services/httpInterceptor';
import appServices from 'services';
import appComponents from 'components';
import appConstants from 'constants';
import appDirectives from 'directives';
import appModals from 'modals';
import appPanels from 'panels';
import appFilters from 'filters';
import 'lib/filepicker';
import authentication from './authentication';
import authorization from './authorization';
import stateChange from './stateChange';
import appConfig from './appConfig';
import routerConfig from './routerConfig';

import './handlebarsHelpers';

import './styles/main.less';

smoothScrollPolyfill.polyfill();

const app = angular.module('nightproApp', [
  'jsSdk',
  'ui.router',
  'permission',
  'permission.ui',
  'ngSegment',
  'ui.bootstrap',
  'datatables',
  'ui.select',
  'daterangepicker',
  'summernote',
  'colorpicker.module',
  'ngOnload',
  'angular-labelauty',
  'ng-currency',
  'ngHandsontable',
  'ngclipboard',
  'angular-slideout-panel',
  'hljs',
  'ngDraggable',
  'angularjs-autogrow',
  'nvd3'
]);

appServices.init(app);
appComponents.init(app);
appConstants.init(app);
appDirectives.init(app);
appModals.init(app);
appPanels.init(app);
appFilters.init(app);

app.factory('npHttpInterceptor', npHttpInterceptor);

app.config(appConfig);
app.config(routerConfig);

app.run(authentication);
app.run(authorization);
app.run(stateChange);

app.config(['$httpProvider',
  ($httpProvider) => {
    $httpProvider.interceptors.push('npHttpInterceptor');
  }
]);

export default app;



// WEBPACK FOOTER //
// ./src/main.js